export const useListProps = () => {
  return {
    path: `/registry-service/feedback-items`,
    selectRowsEnabled: { enabled: false },
    actionBar: { enabled: false },
    pagination: { enabled: false },
  };
};
